import CompleteLogomarkLight from '@ordr-as/logo/CompleteLogomarkLight';

const Logo = () => {
  return (
    <div className="pt-6 pb-3">
      <CompleteLogomarkLight
        height={32}
        width={114}
        // The generated component has a fixed 300x84 size and no viewBox, so resizing it would crop.
        viewBox="0 0 300 84"
        role="img"
        title="Favrit"
        titleId="favrit-logo-title"
      />
    </div>
  );
};

export default Logo;
